export default __webpack_public_path__ + "static/media/share.11f640d2.svg";